import { ColumnSetting } from "lib/types/models";

/**
 * Expanded buyer columns currently only used in frameworks pages.
 * Everywhere else, the smaller subset of columns is used.
 * @deprecated Use BuyerColumns instead unless you are in a framework page
 */
export type ExpandedBuyerColumns =
  | "name"
  | "notice"
  | "country"
  | "town"
  | "region"
  | "signals"
  | "buyerType";
export type BuyerColumns = "name" | "noticeCount" | "country" | "town" | "buyerType";

export const EXPANDED_BUYER_COLUMNS: ColumnSetting<ExpandedBuyerColumns>[] = [
  { title: "Buyer name", field: "name", disabled: true },
  { title: "Notices", field: "notice" },
  { title: "Country", field: "country" },
  { title: "Town", field: "town" },
  { title: "Region", field: "region" },
  { title: "Signals", field: "signals" },
];

export const BUYER_COLUMNS: ColumnSetting<BuyerColumns>[] = [
  { title: "Buyer name", field: "name", disabled: true },
  { title: "Notices", field: "noticeCount" },
  { title: "Type", field: "buyerType" },
  { title: "Country", field: "country" },
  { title: "Town", field: "town" },
];

const expandedColumnCopies: Record<ExpandedBuyerColumns, string> = EXPANDED_BUYER_COLUMNS.reduce(
  (acc, { title, field }) => {
    if (field === "name") {
      return { ...acc, buyer_name: title };
    }
    if (field === "notice") {
      return { ...acc, total_record_count: title };
    }
    return { ...acc, [field]: title };
  },
  {} as Record<ExpandedBuyerColumns, string>,
);

const columnCopies: Record<BuyerColumns, string> = BUYER_COLUMNS.reduce(
  (acc, { title, field }) => {
    return { ...acc, [field]: title };
  },
  {} as Record<BuyerColumns, string>,
);

export const getExpandedBuyersColumnCopy = (column?: string): string => {
  if (!column || !(column in expandedColumnCopies)) return "";
  return expandedColumnCopies[column as ExpandedBuyerColumns];
};

export const getBuyersColumnCopy = (column?: string): string => {
  if (column === "awardCount") {
    return "Awards";
  }
  if (!column || !(column in columnCopies)) return "";
  return columnCopies[column as BuyerColumns];
};
